import React from 'react'
import AuthLayout from '../../layout/AuthLayout'
import { Link } from 'react-router-dom'

const Register = () => {
    return (
        <AuthLayout>
            <div className='self-start tracking-wide w-full'>
                <img src={require('../../assets/logo.svg')} alt='logo' />
                <div className='mt-6'>
                    <h1 className='font-bold tracking-wide text-2xl'>Welcome to WoodSystem</h1>
                </div>
                <div className='mt-10 flex items-center h-12 bb w-full'>
                    <div className=' flex items-center  font-semibold  text-base color-grey h-24 relative'>
                        <Link to='/register'>Register</Link>
                        <div className='absolute pt-10 pr-2 sbb-reg'>
                            <div className='h-1 rounded-full w-20  bg-green '></div>
                        </div>
                    </div>
                    <div className='flex items-center h-24 font-normal text-base ml-16 color-grey opacity-50  h-full relative'>
                        <Link to='/login'>Login</Link>
                    </div>
                </div>

                <div className='mt-10'>
                    <div>
                        <input type='text' placeholder='Company name' />
                    </div>
                    <div className='mt-5'>
                        <input type='text' placeholder='Email' />
                    </div>
                    <div className='mt-5'>
                        <input type='text' placeholder='RC number' />
                    </div>
                    <div className='mt-5'>
                        <input type='text' placeholder='Password' />
                    </div>
                    <div className='mt-5'>
                        <input type='text' placeholder='Select location' />
                    </div>
                    <div className='mt-8'>
                        <button className='w-full bg-green font-semibold text-white tracking-wide text-sm py-5 br-5'>
                            Register
                        </button>
                    </div>
                </div>
            </div>
        </AuthLayout>
    )
}

export default Register
